export default "__VITE_ASSET__BGMBCPZP__"